class MadToggle {
  constructor(container) {
    this.container = container;
    this.buttons = this.container.find('.mad-toggle__button');

    this.init();
  }

  init() {
    this.buttons.on('click', (event) => {
      const button = jQuery(event.currentTarget);
      const toggleId = button.data('button-toggle-id');
      this.setActiveToggle(toggleId, button);
    });
  }

  setActiveToggle(toggleId, clickedButton) {
    // Deactivate all elements and buttons
    const allElements = jQuery('[data-toggle-id]');
    const allButtons = this.buttons;

    allElements.removeClass('active');
    allButtons.removeClass('active');

    // Activate the selected element and button
    const targetElement = jQuery(`[data-toggle-id="${toggleId}"]`);
    if (targetElement.length > 0) {
      targetElement.addClass('active');
      clickedButton.addClass('active');
    }
  }
}

jQuery(document).ready(function () {
  const containers = jQuery('.mad-toggle__container');
  if (containers.length > 0) {
    containers.each(function () {
      new MadToggle(jQuery(this));
    });
  }
});
